import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';
import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';

import { ICON_POSITION } from '../../../../constants';

export type LocationButtonStylesParams = {
  locationButtonDefaultFont: StyleParamType.Font;
  locationButtonDefaultColor: StyleParamType.Color;
  locationButtonHoverFont: StyleParamType.Font;
  locationButtonHoverColor: StyleParamType.Color;
  locationButtonShowIcon: StyleParamType.Boolean;
  locationButtonIconSize: StyleParamType.Number;
  locationButtonIconPosition: StyleParamType.Number;
  locationButtonIconSpacing: StyleParamType.Number;
  locationButtonIconColor: StyleParamType.Color;
};

export const locationButtonStylesParams =
  createStylesParams<LocationButtonStylesParams>({
    locationButtonDefaultFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
      metadata: {
        type: StyleType.font,
        defaultValue: { type: 'static', preset: 'Body-M', size: 16 },
        mobileDefaultValue: { type: 'static', preset: 'Body-M', size: 14 },
        ai: {
          description: 'Font of the location selector button label',
        },
      },
    },
    locationButtonDefaultColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-action', 1),
      metadata: {
        type: StyleType.color,
        defaultValue: { type: 'static', preset: 'color-action', opacity: 1 },
        ai: {
          description: 'Text color of the location selector button label',
        },
      },
    },
    locationButtonHoverFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
      metadata: {
        type: StyleType.font,
        defaultValue: { type: 'static', preset: 'Body-M', size: 16 },
        mobileDefaultValue: { type: 'static', preset: 'Body-M', size: 14 },
        ai: {
          description: 'Font of the location selector button label on hover',
        },
      },
    },
    locationButtonHoverColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-action', 1),
      metadata: {
        type: StyleType.color,
        defaultValue: { type: 'static', preset: 'color-action', opacity: 1 },
        ai: {
          description:
            'Text color of the location selector button label on hover',
        },
      },
    },
    locationButtonShowIcon: {
      type: StyleParamType.Boolean,
      getDefaultValue: () => true,
      metadata: {
        type: StyleType.booleanValue,
        defaultValue: { type: 'static', value: true },
        ai: {
          description:
            'Controls whether the icon is shown on the location selector button',
        },
      },
    },
    locationButtonIconSize: {
      type: StyleParamType.Number,
      getDefaultValue: () => 24,
      metadata: {
        type: StyleType.number,
        defaultValue: { type: 'static', value: 24 },
        ai: {
          description:
            'Size in pixels of the icon on the location selector button',
        },
      },
    },
    locationButtonIconPosition: {
      type: StyleParamType.Number,
      getDefaultValue: () => ICON_POSITION.LEFT,
      metadata: {
        type: StyleType.numberEnum,
        defaultValue: { type: 'static', value: ICON_POSITION.LEFT },
        ai: {
          description:
            'Controls the icon position relative to the location button label — 0 = left, 1 = right, 2 = top, 3 = bottom',
        },
      },
    },
    locationButtonIconSpacing: {
      type: StyleParamType.Number,
      getDefaultValue: () => 8,
      metadata: {
        type: StyleType.number,
        defaultValue: { type: 'static', value: 8 },
        ai: {
          description:
            'Spacing in pixels between the icon and the label on the location selector button',
        },
      },
    },
    locationButtonIconColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-action', 1),
      metadata: {
        type: StyleType.color,
        defaultValue: { type: 'static', preset: 'color-action', opacity: 1 },
        ai: {
          description: 'Color of the icon on the location selector button',
        },
      },
    },
  });
